import React from 'react';
import Select from 'react-select';
import BaseApi from '../../api/BaseApi.js';
import ScreenCaption from '../screen-caption.js';
import details from '../../img/details.svg';
import add from '../../img/add.svg';
import sortasc from '../../img/sort-asc.svg';
import sortdesc from '../../img/sort-desc.svg';
import del from '../../img/del.svg';
import link from '../../img/link.svg';

export default class ProductsScreen extends React.Component {
    constructor(props) {
        super(props);

        var programid = null
        var selectedProgramId = ""
        var sortField = null
        var sortOrder = null
        var pageCount = 0
    

        console.log("===")
        console.log(props.args)

        const args = props.args === undefined ? {} : props.args
        
        if (args.programid) {
            programid = args.programid
        }

        if (args.selectedProgramid) {
            selectedProgramId= args.selectedProgramid
        }

        if (args.pageCount !== undefined) {
            pageCount = args.pageCount
        }

        if (args.sortField !== undefined) {
            sortField = args.sortField
        }

        if (args.sortOrder !== undefined) {
            sortOrder = args.sortOrder
        }

        this.state = {
              args: args,
              pageLimit: 25, 
              pageCount: pageCount,   
              nameCriteria: "",
              prevNameCriteria:"",
              programid: programid, 
              selectedProgramId: selectedProgramId,
              products: [],
              programOptions: [],
              sortField: sortField, 
              sortOrder: sortOrder  
        }

        this.programChangeHandler = this.programChangeHandler.bind(this);  
        this.nameCriteriaChangeHandler = this.nameCriteriaChangeHandler.bind(this); 
        this.sortClicked = this.sortClicked.bind(this);   
        this.nameSearch = this.nameSearch.bind(this);   
        
        setTimeout(this.nameSearch, 2000);

    }  
    
    async componentDidMount() {
        this.getDataWithCriteria()
        
        this.getProgramOptions()
    }

    getDataWithCriteria() {
        var parameters = {}

        if (this.state.programid) {
            parameters.programid = this.state.programid
        }   
        else {
            parameters.programid = this.state.selectedProgramId
        }
        
        if (this.state.nameCriteria.length > 0) {
            parameters.name = this.state.nameCriteria
        }

        parameters.limit = this.state.pageLimit
        parameters.offset = this.state.pageLimit * this.state.pageCount

        if (this.state.sortField) {
            parameters.orderby = this.state.sortField
        }

        if (this.state.sortOrder) {
            parameters.sortorder = this.state.sortOrder
        }

    
        BaseApi.get('/products', {headers: {
            'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, params: parameters, withCredentials: true})
        .then(res => {
            this.setState({products: res.data})
        })    
        .catch(error=>console.log(error))
    }

    getProgramOptions() {
        BaseApi.get("/programs", {headers: {
            'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, params: {list: true}, withCredentials: true})
        .then(res => {
            const programOptions = res.data.map(({id, name}) => ({value: id, label: name}))
            programOptions.push({value: "", label: "Все"})
            this.setState({programOptions: programOptions})
        })    
        .catch()
    }

    nameSearch() {
        if (this.state.nameCriteria !== this.state.prevNameCriteria) {
            var args = this.state.args
            args.pageCount = 0
            this.setState({prevNameCriteria: this.state.nameCriteria, pageCount: 0, args: args}, this.getDataWithCriteria)
        }    
        setTimeout(this.nameSearch, 2000)
    }

    nextPage() {
        var args = this.state.args
        args.pageCount = this.state.pageCount + 1
        this.setState({pageCount: this.state.pageCount + 1}, this.getDataWithCritera)
    }

    prevPage() {
        if (this.state.pageCount > 0) {
            var args = this.state.args
            args.pageCount = this.state.pageCount - 1
            this.setState({pageCount: this.state.pageCount - 1, args: args}, this.getDataWithCriteria)
        }
    }

    isFieldSortedDesc(field) {
        return this.state.sortField === field && this.state.sortOrder === "desc"
    }

    isFieldSortedAsc(field) {
        return this.state.sortField === field && this.state.sortOrder !== "desc"
    } 

    sortClicked(event) {
        var currentField = this.state.sortField
        var currentOrder = this.state.sortOrder
        switch (event.target.id) {
            case "programCaption" :
                if (currentField === "program") {
                    if (currentOrder !== "desc") {
                        currentOrder = "desc"
                    } else {
                        currentOrder = "asc"
                    }
                } else {
                    currentField = "program"
                    currentOrder = "asc"
                }
            break
            case "nameCaption" :
                if (currentField === "name") {
                    if (currentOrder !== "desc") {
                        currentOrder = "desc"
                    } else {
                        currentOrder = "asc"
                    }
                } else {
                    currentField = "name"
                    currentOrder = "asc"
                }
            break         
        }
        var args = this.state.args
        args.pageCount = 0
        args.sortField = currentField
        args.sortOrder = currentOrder
        this.setState({sortField: currentField, sortOrder: currentOrder, pageCount: 0}, this.getDataWithCriteria)
    }

    programChangeHandler(selectedOption) {
        var args = this.state.args
        args.pageCount = 0
        this.setState({selectedProgramId: selectedOption.value, pageCount: 0, args: args}, this.getDataWithCriteria)
    }

    nameCriteriaChangeHandler(event) {
        this.setState({nameCriteria: event.target.value})
    }

    openProduct(id) {
        this.props.navigate("product", {caller: "products", callargs: this.state.args, product: id, program: this.state.programid})
    }

    linkProduct() {
        this.props.navigate("product-select", {caller: "products", callargs: this.state.args, programid: this.state.programid})
    }

    unlinkProduct(id) {
        BaseApi.delete("/product/link", {headers: {
            'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, params: {id: id}, withCredentials: true})
        .then(res => {
            this.getDataWithCriteria()
        })    
        .catch()
    }

    renderProduct(product) {
        return (
            <tr
                id = {product.id}
                className="table-row-clickable"
                onClick={()=>this.openProduct(product.productid)} 
            >
                {this.state.programid === null && 
                    <td style={{textAlign: 'left',  padding: '4px'}}>{product.program}</td>
                }     
                <td style={{textAlign: 'left',  padding: '4px'}}>{product.name}</td>
                <td style={{textAlign: 'left',  padding: '4px'}}>{product.description}</td>
                {/*<td style={{textAlign: 'left',  padding: '4px'}}>{product.orig === 1 ? "Да" : "Нет"}</td>*/}
            </tr>
        )      
    }

    render() {
        return (
            <div class="container">
                <ScreenCaption goback={this.props.goback} args={this.state.args} caption={"Продукты"}/>
                <div className="row mt-4 mb-3">
                    <div className="col-lg-5">
                        <div className="card shadow-sm">
                            <div className="card-body">
                                <h6 className="card-title mb-3">Фильтр</h6>

                                <div className="mb-3">
                                    <label for="name"> Имя:</label>
                                    <input type="text" class="form-control" id="name" value={this.state.nameCriteria} onChange={this.nameCriteriaChangeHandler} />
                                </div>

                                {this.state.programid === null && 
                                <div className="mb-3">  
                                    <label for="program">Программа:</label>
                                    <Select options= {this.state.programOptions} 
                                        id="program" 
                                        onChange={this.programChangeHandler}
                                        />
                                </div>     
                            }       
                            </div>
                        </div>
                    </div>
                    {/* Кнопка "Добавить продукт" справа */}
                    <div className="col-lg-7 d-flex align-items-start justify-content-end mt-3 mt-lg-0">
                        <button
                            type="button"
                            className="btn btn-primary d-flex align-items-center"
                            onClick={() => this.openProduct("")}
                        >
                            Добавить продукт
                        </button>  
                    </div>
                </div>
                
                <div className="card shadow-sm">
                    <div className="card-body p-0">
                        <div className="table-responsive">
                            <table className="table table-sm table-hover mb-0 align-middle">
                                <thead className="table-primary">
                                    <tr>
                                         {this.state.programid === null && 
                                            <th 
                                                id="programCaption"
                                                onClick={this.sortClicked}
                                                style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}
                                            >
                                                Программа {' '}
                                                {this.isFieldSortedDesc("program") && <img src={sortdesc} height="16" width="16"/>}
                                                {this.isFieldSortedAsc("program") && <img src={sortasc} height="16" width="16"/>}
                                            </th>
                                        }
                                        <th
                                            id="nameCaption"
                                            onClick={this.sortClicked}
                                            style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}    
                                        >
                                            Наименование {' '}
                                            {this.isFieldSortedDesc("name") && <img src={sortdesc} height="16" width="16"/>}
                                            {this.isFieldSortedAsc("name") && <img src={sortasc} height="16" width="16"/>}    
                                        </th>
                                        <th style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>
                                            Описание
                                        </th>
                                        {/*
                                        <th style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>
                                            Исходный
                                        </th>
                                        */}
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.products.map((value, index) => this.renderProduct(value))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div> 
        )
    }
}    


// WEBPACK FOOTER //
// ./src/ui/workspace-screens/products.js